import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import DailySecuriyReportTable from "./DailySecurityReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { DailySecurityReportFilter } from "./DailySecurityReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const DailySecurityReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="secCommDailyTradeReportTitle" />}
              action={<DailySecurityReportActions />}
            />
            <Divider />
            <CardContent>
              <DailySecuriyReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const DailySecurityReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DailySecurityReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default DailySecurityReport;
